/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppEmbeddedSignupResetSignup } from '../../axios/whatsAppEmbeddedSignupResetSignup'
import type {
	WhatsAppEmbeddedSignupResetSignupError,
	WhatsAppEmbeddedSignupResetSignupPathParams,
	WhatsAppEmbeddedSignupResetSignupResponse,
} from '../../types/WhatsAppEmbeddedSignupResetSignup'

export const whatsAppEmbeddedSignupResetSignupMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-account/signup/reset' }] as const

export type WhatsAppEmbeddedSignupResetSignupMutationKey = ReturnType<
	typeof whatsAppEmbeddedSignupResetSignupMutationKey
>

export type WhatsAppEmbeddedSignupResetSignupVariables = {
	organisationId: WhatsAppEmbeddedSignupResetSignupPathParams['organisationId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::resetSignup */
export function useWhatsAppEmbeddedSignupResetSignup<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppEmbeddedSignupResetSignupResponse,
		AxiosError<WhatsAppEmbeddedSignupResetSignupError>,
		WhatsAppEmbeddedSignupResetSignupVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppEmbeddedSignupResetSignupMutationKey(),
		mutationFn: ({ organisationId }: WhatsAppEmbeddedSignupResetSignupVariables) =>
			whatsAppEmbeddedSignupResetSignup(organisationId, config).then(res => res.data),
		...options,
	})
}
